import UpdateLesson from "./UpdateLesson";
import MainPage from "../../templatePage/templatePage";

const UpdateLessonPage = () => {
  return <MainPage component={<UpdateLesson />} />;
};

export default UpdateLessonPage;